import { TAMANHO_MINIMO_JUSTIFICATIVA } from './conferencia-itens'
import type { ErroValidacaoItem } from './conferencia-itens'
import type { ErroImportacaoPlanilha } from './planilha-itens'

type TextosFollowUp = Record<string, string>

export const TEXTOS_ORDENS_COMPRA = {
  tituloRegiao: 'Cotações',
  tituloTabela: 'Cotações',
  dica: 'Abra os detalhes para conferir os itens e responder ao comprador',
  erroConsulta: 'Erro ao buscar as cotações!',
  vazio: 'Nenhuma cotação pendente para o seu fornecedor.',
  atualizar: 'Atualizar cotações',
  detalhes: 'Detalhes',
} as const satisfies TextosFollowUp

export const COLUNAS_ORDENS_COMPRA = {
  numero: 'Nro',
  fatura: 'Fatura',
  giro: 'Giro',
  comprador: 'Iniciou',
  quantidadeItens: 'Qtde Itens',
  valorTotal: 'Valor Total',
  acoes: 'Ações',
} as const satisfies TextosFollowUp

export const TEXTOS_ITENS_ORDEM_COMPRA = {
  titulo: 'Itens da cotação',
  erroConsulta: 'Erro ao buscar os itens da cotação!',
  erroFinalizacao: 'Erro ao finalizar a conferência da cotação.',
  sucessoFinalizacao: 'Conferência finalizada e cotação enviada para aprovação!',
  vazio: 'Nenhum item encontrado para esta cotação.',
  finalizar: 'Finalizar conferência',
  tituloConfirmacaoFinalizacao: 'Tem certeza de que deseja finalizar a conferência?',
  descricaoConfirmacaoFinalizacao: 'Este procedimento é irreversível.',
  confirmarFinalizacao: 'Sim, finalizar',
  cancelarFinalizacao: 'Cancelar',
  fechar: 'Fechar',
  dicaJustificativa: `Alterar preço de compra ou quantidade exige justificativa com no mínimo ${TAMANHO_MINIMO_JUSTIFICATIVA} caracteres.`,
  resumoPendencias: 'Corrija os itens destacados para finalizar a conferência.',
  gerarExcel: 'Gerar arquivo excel',
  importarExcel: 'Importar arquivo excel',
  erroGeracaoExcel: 'Erro ao gerar o arquivo excel da cotação.',
  sucessoImportacaoExcel: 'Itens atualizados a partir do arquivo:',
  codigosNaoEncontradosExcel: 'Códigos do arquivo não encontrados nesta cotação:',
} as const satisfies TextosFollowUp

export const CABECALHOS_PLANILHA_ITENS = {
  codigo: 'Cód Produto',
  codigoFabrica: 'Cód Fabricante',
  descricao: 'Descrição',
  precoCompra: 'P Compra',
  quantidade: 'Quantidade',
  justificativa: 'Justificativa',
  valorTotal: 'Valor Total',
  previsaoEntrega: 'Prev Entrega',
} as const satisfies TextosFollowUp

export const TEXTOS_RESUMO_ORDEM_COMPRA = {
  tituloFilial: 'Filial Fatura / Entrega',
  tituloOrdemCompra: 'Cotação',
  erroConsultaFilial: 'Erro ao buscar os dados da filial de faturamento!',
  filialIndisponivel: 'Dados da filial de faturamento indisponíveis.',
} as const satisfies TextosFollowUp

export const CAMPOS_RESUMO_FILIAL = {
  razaoSocial: 'Razão Social',
  endereco: 'Endereço',
  cidade: 'Cidade',
  cnpj: 'CNPJ',
  cep: 'CEP',
} as const satisfies TextosFollowUp

export const CAMPOS_RESUMO_ORDEM_COMPRA = {
  numero: 'Nro',
  quantidadeItens: 'Nro Itens',
  valorTotal: 'Valor Total',
} as const satisfies TextosFollowUp

export const COLUNAS_ITENS_ORDEM_COMPRA = {
  codigo: 'Código',
  codigoFabrica: 'Código de fábrica',
  descricao: 'Descrição',
  precoCompra: 'Preço de compra',
  quantidade: 'Quantidade',
  justificativa: 'Justificativa',
  valorTotal: 'Valor total',
  dataUltimaEntrega: 'Data de última entrega',
  previsaoEntrega: 'Previsão de entrega',
} as const satisfies TextosFollowUp

export const MENSAGENS_VALIDACAO = {
  'justificativa-obrigatoria': `Informe a justificativa da alteração de preço de compra ou quantidade, com no mínimo ${TAMANHO_MINIMO_JUSTIFICATIVA} caracteres.`,
  'justificativa-curta': `A justificativa precisa ter no mínimo ${TAMANHO_MINIMO_JUSTIFICATIVA} caracteres.`,
} as const satisfies Record<ErroValidacaoItem, string>

export const MENSAGENS_IMPORTACAO_PLANILHA = {
  'arquivo-invalido': 'Não foi possível ler o arquivo. Selecione uma planilha excel válida.',
  'cabecalho-invalido': `A planilha precisa das colunas ${CABECALHOS_PLANILHA_ITENS.codigo}, ${CABECALHOS_PLANILHA_ITENS.precoCompra}, ${CABECALHOS_PLANILHA_ITENS.quantidade}, ${CABECALHOS_PLANILHA_ITENS.justificativa} e ${CABECALHOS_PLANILHA_ITENS.previsaoEntrega}.`,
  'sem-itens-correspondentes': 'Nenhum item da planilha corresponde aos itens desta cotação.',
} as const satisfies Record<ErroImportacaoPlanilha, string>
